import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class OnramperService {
    constructor(private http: HttpClient) { }

    checkStatus(partnerContext: string): Observable<IonramperTxStatus> {
        let test = "https://stingray-app-4qz4a.ondigitalocean.app/"
        return this.http.get<IonramperTxStatus>(/* environment.apiBaseUrlV22  */test + "onramper/status/" + partnerContext);
    }
}

export interface IonramperTxStatus {
    status: | 'pending' | 'completed'
}